import { useCallback } from 'react'

import { FeeType } from 'types/graphql'

import FeeTemplateSelect from 'src/components/Selects/FeeTemplateSelect'

import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  allowedTypes?: FeeType[]
  caption?: React.ReactNode
  field: TanstackField<number | null | undefined, TKey>
  isClearable?: boolean
  isDisabled?: boolean
  label?: React.ReactNode
  onValueChange?: (value: number | null | undefined) => void
}
const FeeTemplateSelectField = <TKey extends string>({
  allowedTypes,
  caption,
  field,
  isClearable,
  isDisabled,
  label,
  onValueChange,
}: Props<TKey>) => {
  const handleValueChange = useCallback(
    (value: number | null | undefined) => {
      field.setValue(value)
      onValueChange?.(value)
    },
    [field, onValueChange]
  )

  return (
    <FeeTemplateSelect
      isMultiSelect={false}
      allowedTypes={allowedTypes}
      caption={caption}
      isClearable={isClearable}
      isDisabled={isDisabled}
      label={label}
      onValueChange={handleValueChange}
      value={field.state.value}
    />
  )
}

export default FeeTemplateSelectField
